import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import SelectBox from '../component/Select.js';
import loader from '../asset/img/loader.gif';
import Modal from 'react-modal';

Modal.setAppElement('#root');

export default class ViewUsers extends Component {
	constructor(props){
		super(props);
		this.state = {users:[],selected:{},userTypes:[],modalIsOpen:false,loading:false,confirmationMessage:''};
		this.handleClick = this.handleClick.bind(this);
		this.getData = this.getData.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.getUsers = this.getUsers.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	getUsers(){ //method for retrieving users and user_types from DB
		axios({ //retrieve all users
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'users',action:"view"}
		}).then((response)=>{
			let users = [];
			let data = response.data.data;
			data.forEach((user)=>{
				users.push(user);
			});
			this.setState({users:users},function(){
				this.getData(users[0],0);
			});
		});
		axios({ //retrieve user types
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'user_type'}
		}).then((response)=>{
			let types = [];
			let data = response.data.data;
			data.forEach((type)=>{
				types.push(type.type);
			});
			this.setState({userTypes:types});
		});
	}

	componentDidMount(){
		this.getUsers();
	}

	getData(user,index){ //method to retrieve user stats for the selected user
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'points',userID:user.userID}
		}).then((response)=>{

			let data = response.data.data;
			let merge = {...data[0],...user,...{index:index}};
			this.setState({selected:merge});
		});
	}

	handleSelect(identity,value){ //method for handling user input
		let selected = this.state.selected;
		selected[identity] = value;
		this.setState({selected:selected});
		let misc;
		if(identity === 'user_status'){ //update user status (active or inactive) on change
			let index = selected.index;
			let users = this.state.users;
			users[index].user_status = value;
			this.setState({users:users});
			misc = "status";
		}else{ //update usertype on change
			misc = "type";
		}
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'users',misc:misc,firstID:selected.userID,status:value}
		});
	}

	handleClick(e){ //handles retrieving user data based on which user name was clicked
		this.state.users.filter((user)=>{
			if(user.userID === Number(e.target.id)){
				this.getData(user,e.target.name);
			}
		});
	}

	closeModal(){
		this.setState({modalIsOpen:false,confirmationMessage:''});
	}

	resetPassword(){
		this.setState({loading:true});
		axios({
			method:'post',
			url: path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'users',misc:'security_reset',firstID:this.state.selected.userID}
		}).then((response)=>{
			this.setState({confirmationMessage:response.data.data.Message},function(){
				this.setState({loading:false});
			});
		}).catch((error)=>{
			this.setState({confirmationMessage:"There has been a problem. Please try again later."},function(){
				this.setState({loading:false});
			});
		});
	}

	componentDidUpdate(prevProps,prevState){ //if new users are created, retrieve the updated user list
		if(prevProps.submitted !== this.props.submitted){
			this.getUsers();
		}
	}

	render(){
		let modalContent;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minHeight: '195px',
		    maxWidth:'500px',
		    transform: 'translate(-50%, -50%)',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '280px 252px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)',
			}
		};
		const labelStyle="fl w-50 f3 navy";
		const spanStyle = "dark-blue";
		const selectStyles = "h2 pa1 w-90 br2 bw1 truncate shadow-3 bg-near-white";
		let content;
		const status = ["active","inactive"];
		const pStyle = "f3 navy bb b--light-silver";
		let promptContent;
		if(!this.state.loading){
			if(this.state.confirmationMessage === ''){
				promptContent = <div className="tc">
									<p className="navy b f4">Are you sure you want to reset {this.state.selected.name}'s security information?</p>
									<div style={{width:'200px',margin:'auto'}}>
										<span onClick={this.resetPassword} className="mr2 yes_button white">Yes</span>
										<span onClick={this.closeModal} className="no_button white">No</span>
									</div>
								</div>;
			}else{
				promptContent = <div className="tc">
									<p className="navy b f4">{this.state.confirmationMessage}</p>
								</div>;
			}
			modalContent = <div>
								<div className="w-100 tr">
						        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
						        </div>
						        {promptContent}
							</div>;
		}else{
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading..." /></div>;
		}
		if(this.props.active){
			content =   <div>
							<div className="fl w-25 mb2" style={{maxHeight:'500px',height:'500px'}}>
								<UnorderedList users={this.state.users} onClick={this.handleClick}/>
							</div>
							<div className="fl w-75 br3 pb3 pl2 bg-white mt2" style={{boxShadow:'0px 0px 3px 3px #aaaaaa inset',height:'540px'}}>
								<div style={{maxWidth:'400px', margin:'auto'}} className="mt3">
									<p className="f2 tc underline mt_3 navy">{this.state.selected.name}</p>
									<p className={pStyle}>Points Earned: <span className={spanStyle}>{this.state.selected.earned}</span>/<span className={spanStyle}>{this.state.selected.cap}</span></p>
									<p className={pStyle}>Points Redeemed: <span className={spanStyle}>{this.state.selected.redeemed}</span>/<span className={spanStyle}>{this.state.selected.cap}</span></p>
									<p className={pStyle}>Points Redeemable: <span className={spanStyle}>{this.state.selected.redeemable}</span>/<span className={spanStyle}>{this.state.selected.cap}</span></p>
									<p className={pStyle}>Sent Thank Yous: <span className={spanStyle}>{this.state.selected.sent}</span></p>
									<p className={pStyle}>Received Thank Yous: <span className={spanStyle}>{this.state.selected.received}</span></p>
									<div className="fl w-100 mb3">
										<label className={labelStyle}>User Type: </label>
										<div className=" tl fl w-50">
											<SelectBox identity="user_type" options={this.state.userTypes} val={this.state.selected.user_type} onSelect={this.handleSelect} styles={selectStyles}/>
										</div>
									</div>
									<div className="fl w-100 mb4">
										<label className={labelStyle}>User Status: </label>
										<div className=" tl fl w-50">
											<SelectBox identity="user_status" options={status} val={this.state.selected.user_status} onSelect={this.handleSelect} styles={selectStyles}/>
										</div>
									</div>
									<div className="fl w-100 pb3 pt1">
										<div style={{width:'169px',margin:'auto',paddingBottom:'5px'}}>
											<span className="shadow-3" id="reset_password" onClick={()=>this.setState({modalIsOpen:true})}>Reset Security Info</span>
										</div>
									</div>
								</div>
							</div>
							<Modal
								isOpen={this.state.modalIsOpen}
								style={customStyles}
								contentLabel="Admin Security Reset"
								shouldCloseOnOverlayClick={false}
								shouldCloseOnEsc={false}
					        >
					        {modalContent}
					        </Modal>
						</div>;
		}
		return(
			<div>
				{content}
			</div>
		);
	}
}

const UnorderedList = props =>{ //unordered list function component for displaying the list of all users, separated by their status (active or inactive)
	const p = "tc b underline";
	const activeUserList = [];
	const inactiveUserList = [];
	props.users.forEach((user,i)=>{
		if(user.user_status !== "inactive"){
			activeUserList.push(<li key={i} className="mb1"><a href="#" className="dark-blue no-underline underline-hover" name={i} id={user.userID} onClick={props.onClick}>{user.name}</a></li>);
		}else{
			inactiveUserList.push(<li key={i} className="mb1"><a href="#" className="mid-gray no-underline underline-hover" name={i} id={user.userID} onClick={props.onClick}>{user.name}</a></li>);
		}
	});

	return (<div>
						<p className={p}>Active Users</p>
						<ul className="list pl2 overflow-y-auto bb b--light-silver" style={{maxHeight:'200px'}}>{activeUserList}</ul>
						<p className={p}>Inactive Users</p>
						<ul className="list pl2 overflow-y-auto" style={{maxHeight:'200px'}}>{inactiveUserList}</ul></div>);
};


// WEBPACK FOOTER //
// ./src/container/ViewUsers.js